import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";

const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = useCallback((message) => {
    setMessages((prevMessages) => {
      return [...prevMessages, message];
    });
  }, []);

  const removeMessage = useCallback((id) => {
    setMessages((prevMessages) => prevMessages.filter((msg) => msg.id !== id));
  }, []);

  const contextValues = useMemo(
    () => ({ addMessage, removeMessage, messages }),
    [addMessage, removeMessage, messages]
  );

  return (
    <ToasterContext.Provider value={contextValues}>
      {children}
    </ToasterContext.Provider>
  );
};

export const useToaster = () => useContext(ToasterContext);
